const Toast = {
  install(Vue) {
    Vue.prototype.$toast = {
      // Warning toast
      warning(message) {
        return Vue.prototype.$swal({
          icon: "warning",
          text: message,
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
      },

      // Error toast
      error(message) {
        return Vue.prototype.$swal({
          icon: "error",
          text: message,
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
      },

      // Success toast
      success(message) {
        return Vue.prototype.$swal({
          icon: "success",
          text: message,
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
      },

      // General method that accepts options object
      show(options) {
        const defaultOptions = {
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        };

        // If it's a simple string, treat as text
        if (typeof options === "string") {
          return Vue.prototype.$swal({
            ...defaultOptions,
            text: options,
            icon: "info",
          });
        }

        // Merge with default options
        const mergedOptions = { ...defaultOptions, ...options };

        // If no toast-specific positioning is needed, remove toast mode for dialogs
        if (options.showCancelButton || options.showConfirmButton !== false) {
          delete mergedOptions.toast;
          delete mergedOptions.position;
          delete mergedOptions.timer;
        }

        return Vue.prototype.$swal(mergedOptions);
      },
    };
  },
};

export default Toast;
